<template>
  <v-container fluid grid-list-md text-xs-center>
    <v-card>
      <v-card-title>
        <h1>Add prefix/suffix to lines</h1>
      </v-card-title>
      <v-card-text>
        <v-layout row wrap>
          <v-flex xs6>
            <v-text-field placeholder="Paste your prefix string here" v-model="prefix"></v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-text-field placeholder="Paste your suffix string here" v-model="suffix"></v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-textarea placeholder="Paste your lines here" v-model="text"></v-textarea>
          </v-flex>
          <v-flex xs6>
            <v-textarea placeholder="Result" v-model="result"></v-textarea>
          </v-flex>
          <v-flex xs12>
            <v-btn color="primary" @click="add()">Add</v-btn>
          </v-flex>
          <actions :result="result" />
        </v-layout>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    text: '',
    result: '',
    prefix: '',
    suffix: ''
  }),
  methods: {
    add() {
      let lines = this.text.split('\n')
      this.result = lines.map((line) => `${this.prefix}${line}${this.suffix}`).join('\n')
    }
  }
}
</script>

<style>
</style>